import React from 'react';
import { Stack, Box, Typography } from '@mui/material';

const Section = ({ title, children, headerChildren, sx = {} }) => {
  return (
    <Stack sx={{ p: 2, backgroundColor: '#FFF', ...sx }}>
      {/* 섹션 헤더 */}
      <Box sx={{ mb: 2, pb: 1, borderBottom: '2px solid #f0f0f0' }}>
        {title ? (
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <Typography sx={{ fontWeight: 'bold' }}>{title}</Typography>
            {headerChildren}
          </Box>
        ) : (
          headerChildren
        )}
      </Box>
      
      {/* 섹션 바디 */}
      {children}
    </Stack>
  );
};

export default Section;
